import type { DecisionEngineChannelType } from "@hightouch/lib/customer-data/decision-engine/types";
import {
  IconBox,
  type IconBoxColors,
  type IconBoxVariant,
  Tooltip,
  type IconAccessory,
} from "@hightouch/htui";
import type { FC } from "react";

import { ChannelOptionsMap } from "src/pages/decision-engines/utils";

export const ChannelColor: Record<DecisionEngineChannelType, IconBoxColors> = {
  email: "blue",
  sms: "pink",
  push: "orange",
  inapp: "indigo",
  raw: "gray",
  surface: "teal",
  journey: "green",
};

export const ChannelIcon: FC<
  Readonly<{
    type: DecisionEngineChannelType;
    label?: string | null;
    size?: "sm" | "md" | "lg" | "xl";
    variant?: IconBoxVariant;
  }>
> = ({ type, label, size = "sm", variant = "default" }) => {
  const Icon = ChannelOptionsMap[type].icon;
  const channelLabel = label || ChannelOptionsMap[type].label;

  return (
    <Tooltip message={channelLabel}>
      <IconBox
        icon={<Icon />}
        color={ChannelColor[type]}
        size={size}
        variant={variant}
      />
    </Tooltip>
  );
};

export function getChannelIconAccessory(
  type: DecisionEngineChannelType,
): IconAccessory {
  const Icon = ChannelOptionsMap[type].icon;
  return {
    type: "icon-box",
    icon: <Icon />,
    color: ChannelColor[type],
    variant: "default",
    size: "md",
    tooltip: ChannelOptionsMap[type].label,
  };
}
